module.exports = __webpack_public_path__ + "static/img/logo.ceb39a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/championscity/logo.png
// module id = xF8e
// module chunks = 1